import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Gallery from "@/components/Gallery";
import Guide from "@/components/Guide";
import Faq from "@/components/Faq";
import CtaCloser from "@/components/CtaCloser";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import useCtaTracker from "@/lib/useCtaTracker";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";

const Landing = () => {
  useCtaTracker();
  return (
    <SmoothScroll>
      <div className="App relative" data-testid="landing-page">
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Manifesto />
          <Gallery />
          <Guide />
          <Faq />
          <CtaCloser />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
